import { Stack } from "@mui/material"
import { GrantedSection } from "./granted-section"
import { OverridesSection } from "./overrides-section"
import { RemovedSection } from "./removed-section"
import { FinalSection } from "./final-section"

/**
 * Granted → Overrides → Removed → Final (FIQ-1926).
 *
 * The order reflects the pipeline. Overrides are applied BEFORE the removal stages, so a
 * granted demand can still be removed afterwards by the role filter or the server_demands
 * gate — Removed sits after Overrides precisely so that reads correctly.
 */
export function AccessBreakdown() {
    return (
        <Stack spacing={2}>
            <GrantedSection />
            <OverridesSection />
            <RemovedSection />
            <FinalSection />
        </Stack>
    )
}
